/* élé living, Bestikbakke landingsside (Shopify-tema-version)
   Kurven er Shopifys rigtige kurv (Ajax Cart API). Findes élés Rebuy Smart Cart, åbnes den.
   Variant-ID'er, priser og titler kommer fra produkterne via data-attributter på [data-ele-lp].
   Uden JS poster alle formularer til /cart/add, og Shopify sender kunden til /cart.
   Pixel: Shopifys egne kundeevents (Meta-kanalen) fanger sidevisning og læg-i-kurv.
   Events skubbes også til dataLayer til GTM. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ele-lp]');
  if (!root) return;
  var d = root.dataset;
  var PLANS = {
    stor:  { id: parseInt(d.storId, 10),  price: parseInt(d.storPrice, 10),  title: d.storTitle },
    lille: { id: parseInt(d.lilleId, 10), price: parseInt(d.lillePrice, 10), title: d.lilleTitle },
    pakke: { id: parseInt(d.pakkeId, 10), price: parseInt(d.pakkePrice, 10), title: d.pakkeTitle, compare: parseInt(d.pakkeCompare, 10) || 0 }
  };
  var DEFAULT_PLAN = 'stor';
  var SHIPPING_PAKKESHOP = 4900;   // 49 kr
  var FREE_SHIPPING_OVER = 79900;  // "ved køb over 799 kr"

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function kr(ore) {
    var neg = ore < 0; ore = Math.abs(ore);
    var v = (ore / 100).toFixed(2).split('.');
    var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (neg ? '-' : '') + whole + (v[1] === '00' ? '' : ',' + v[1]) + ' kr';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shippingFor(sub) { return sub > FREE_SHIPPING_OVER ? 0 : SHIPPING_PAKKESHOP; }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  window.dataLayer = window.dataLayer || [];
  function track(name, key, qty) {
    var p = PLANS[key] || PLANS[DEFAULT_PLAN];
    window.dataLayer.push({ event: name, ecommerce: { currency: 'DKK', value: p.price * (qty || 1) / 100, items: [{ item_id: String(p.id), item_name: p.title, price: p.price / 100, quantity: qty || 1 }] } });
  }

  /* ---------- Shopify Ajax Cart ---------- */
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function api(path, body) {
    return fetch(ROOT_URL + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin'
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fejl'); return j; }); });
  }
  var cart = { items: [], item_count: 0, total_price: 0 };

  /* ---------- købsblok: størrelse + regnestykke ---------- */
  var selected = DEFAULT_PLAN;
  function renderBuy() {
    var p = PLANS[selected], sub = p.price, ship = shippingFor(sub);
    $$('[data-math-row]').forEach(function (r) { r.hidden = selected !== 'pakke'; });
    $('[data-math-label]').textContent = '1 stk. ' + p.title;
    $('[data-math-sub]').textContent = kr(sub);
    $('[data-math-ship]').textContent = ship ? kr(ship) : '0 kr (fri fragt)';
    $('[data-math-total]').textContent = kr(sub + ship);
    $('[data-buy-price]').textContent = kr(sub);
    $('[data-sticky-price]').textContent = kr(sub);
    $('[data-sticky-name]').textContent = p.title;
    $('[data-sticky-id]').value = String(p.id);
  }
  function selectPlan(key) {
    if (!PLANS[key]) return;
    selected = key;
    var r = $('[data-buy-form] input[data-plan="' + key + '"]'); if (r) r.checked = true;
    renderBuy();
  }
  $$('[data-buy-form] input[name="id"]').forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) selectPlan(r.dataset.plan); });
    if (r.checked) selected = r.dataset.plan;
  });
  $$('[data-pick-plan]').forEach(function (a) { a.addEventListener('click', function () { selectPlan(a.dataset.pickPlan); }); });

  /* ---------- kurv: élés Rebuy, ellers egen skuffe ---------- */
  var drawer = $('#cart'), overlay = $('[data-cart-overlay]'), lastFocus = null;
  function showError(msg) { var e = $('[data-cart-error]'); if (!e) return; e.textContent = msg || ''; e.hidden = !msg; }
  function rebuyCart() { var R = window.Rebuy; return R && R.SmartCart && typeof R.SmartCart.show === 'function' ? R.SmartCart : null; }

  function renderCart() {
    var count = cart.item_count || 0, sub = cart.total_price || 0, ship = count ? shippingFor(sub) : 0;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = String(count); });
    var openBtn = $('[data-cart-open]');
    if (openBtn) openBtn.setAttribute('aria-label', 'Åbn kurven, ' + count + (count === 1 ? ' vare' : ' varer'));
    $('[data-cart-empty]').hidden = count > 0;
    $('[data-cart-foot]').hidden = count === 0;
    $('[data-cart-lines]').innerHTML = (cart.items || []).map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=144' : '';
      return '<li class="line">' + (img ? '<img src="' + esc(img) + '" width="72" height="72" loading="lazy" alt="">' : '<span></span>') +
        '<div class="line__info"><p class="line__name">' + esc(it.product_title) + '</p><p class="small muted">' + kr(it.final_price) + ' pr. stk</p>' +
        '<div class="qty" role="group" aria-label="Antal af ' + esc(it.product_title) + '">' +
        '<button type="button" class="icon-btn" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Én færre"><svg class="icon" aria-hidden="true"><use href="#i-minus"/></svg></button>' +
        '<output aria-live="polite">' + it.quantity + '</output>' +
        '<button type="button" class="icon-btn" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Én mere"><svg class="icon" aria-hidden="true"><use href="#i-plus"/></svg></button>' +
        '</div></div><button type="button" class="link-quiet small" data-line="' + (i + 1) + '" data-q="0">Fjern</button></li>';
    }).join('');
    $('[data-cart-sub]').textContent = kr(sub);
    $('[data-cart-shipcost]').textContent = ship ? kr(ship) : '0 kr (fri fragt)';
    $('[data-cart-total]').textContent = kr(sub + ship);
    $('[data-ship-bar]').style.width = Math.min(100, Math.round(sub / FREE_SHIPPING_OVER * 100)) + '%';
    $('[data-ship-text]').textContent = sub > FREE_SHIPPING_OVER ? 'Du har fri fragt til pakkeshop.' : 'Fri fragt til pakkeshop ved køb over 799 kr. Din kurv: ' + kr(sub) + '.';
  }
  function refreshCart() { return api('cart.js').then(function (c) { cart = c; renderCart(); }).catch(function () {}); }
  function focusables() {
    return $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer).filter(function (el) { return !el.closest('[hidden]'); });
  }
  function openCart(ownDrawer) {
    var rb = !ownDrawer && rebuyCart();
    if (rb) { try { if (typeof rb.setCartAsync === 'function') rb.setCartAsync(); } catch (e) {} rb.show(); return; }
    lastFocus = document.activeElement;
    drawer.hidden = false; overlay.hidden = false; document.body.style.overflow = 'hidden';
    var f = focusables(); (f[0] || drawer).focus();
  }
  function closeCart() {
    drawer.hidden = true; overlay.hidden = true; document.body.style.overflow = ''; showError('');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  drawer.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); closeCart(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  overlay.addEventListener('click', closeCart);
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { refreshCart(); openCart(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  $('[data-cart-lines]').addEventListener('click', function (e) {
    var b = e.target.closest('[data-line]'); if (!b) return;
    b.disabled = true;
    api('cart/change.js', { line: parseInt(b.dataset.line, 10), quantity: Math.max(0, parseInt(b.dataset.q, 10)) })
      .then(function (c) { cart = c; renderCart(); if (!c.item_count) { var x = $('[data-cart-close]'); if (x) x.focus(); } })
      .catch(function (err) { showError(err.message); b.disabled = false; });
  });

  /* Læg i kurv */
  $$('[data-add-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var key = form.hasAttribute('data-sticky-form') ? selected : (form.dataset.plan || selected);
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      api('cart/add.js', { items: [{ id: PLANS[key].id, quantity: 1 }] })
        .then(function () { track('add_to_cart', key, 1); return refreshCart(); })
        .then(function () { openCart(); })
        .catch(function (err) { refreshCart().then(function () { openCart(true); showError(err.message); }); })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });
  $('[data-checkout]').addEventListener('click', function () { track('begin_checkout', selected, cart.item_count || 1); });

  /* ---------- galleri ---------- */
  var main = $('[data-gallery-main]');
  $$('.gallery__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $$('.gallery__thumb').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      btn.setAttribute('aria-pressed', 'true');
      main.srcset = btn.dataset.srcset; main.src = btn.dataset.src; main.alt = btn.dataset.alt;
    });
  });

  /* ---------- pasform-tjek (kun publicerede mål) ---------- */
  var SIZES = { stor: { min: 35, max: 58, d: 43, h: 6.5 }, lille: { min: 29.7, max: 41, d: 33.5, h: 5 } };
  var fitForm = $('[data-fit-form]'), fitOut = $('[data-fit-result]'), chart = $('[data-chart]');
  function num(v) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) && n > 0 ? n : null; }
  function cm(n) { return String(Math.round(n * 10) / 10).replace('.', ',') + ' cm'; }
  function fits(s, w, dd, h) { return w >= SIZES[s].min && dd >= SIZES[s].d && (h === null || h >= SIZES[s].h); }
  if (fitForm) fitForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var w = num(fitForm.w.value), dd = num(fitForm.d.value), h = num(fitForm.h.value);
    if (!w || !dd) { fitOut.textContent = 'Skriv mindst bredde og dybde i cm.'; return; }
    var max = Math.max(60, Math.ceil(Math.max(w, dd) / 15) * 15);
    chart.style.setProperty('--max', max);
    var axis = $('.chart__axis');
    if (axis) axis.innerHTML = [0, 1, 2, 3, 4].map(function (i) { return '<span>' + (max / 4 * i) + (i === 4 ? ' cm' : '') + '</span>'; }).join('');
    [['w', w], ['d', dd]].forEach(function (p) {
      var row = $('[data-you="' + p[0] + '"]', chart); row.hidden = false;
      row.querySelector('.chart__fill').style.setProperty('--v', p[1]);
      row.querySelector('.chart__val').textContent = 'Din skuffe: ' + cm(p[1]);
    });
    var pick = null, msg = '';
    if (fits('stor', w, dd, h)) {
      pick = 'stor';
      if (fits('lille', w, dd, h) && w <= SIZES.lille.max) msg = '<strong>Begge passer.</strong> Den store fylder mest ud, fordi skuffen er mindst 43 cm dyb.';
      else msg = '<strong>Den store passer til din skuffe.</strong> ' + (w > SIZES.stor.max ? 'Din skuffe er ' + cm(w) + ' bred, så der bliver ' + cm(w - SIZES.stor.max) + ' tom plads ved siden af bakken.' : 'Træk siderne ud til ' + cm(w) + '.');
    } else if (fits('lille', w, dd, h)) {
      pick = 'lille';
      msg = '<strong>Den lille passer til din skuffe.</strong> ' + (dd < SIZES.stor.d ? 'Den store er 43 cm dyb, og din skuffe er ' + cm(dd) + '.' : 'Din skuffe er for smal til den store (min. 35 cm).') + (w > SIZES.lille.max ? ' Der bliver ' + cm(w - SIZES.lille.max) + ' tom plads ved siden af.' : '');
    } else {
      var why = [];
      if (w < SIZES.lille.min) why.push('bredden er under 29,7 cm');
      if (dd < SIZES.lille.d) why.push('dybden er under 33,5 cm');
      if (h !== null && h < SIZES.lille.h) why.push('den frie højde er under 5 cm');
      msg = '<strong>Ingen af dem passer.</strong> ' + (why.length ? 'Fordi ' + why.join(' og ') + '.' : '') + ' Skriv til info@eleleving.com, så hjælper vi.';
    }
    fitOut.innerHTML = msg + (pick ? '<br><a class="btn btn--primary" href="#koeb" data-pick-plan="' + pick + '">Vælg ' + (pick === 'stor' ? 'den store, ' : 'den lille, ') + kr(PLANS[pick].price) + '</a>' : '');
    var a = fitOut.querySelector('[data-pick-plan]'); if (a) a.addEventListener('click', function () { selectPlan(pick); });
  });

  /* ---------- videoer ---------- */
  var hero = $('[data-hero-video]');
  if (hero && !reduceMotion) { hero.preload = 'auto'; var p0 = hero.play(); if (p0 && p0.catch) p0.catch(function () {}); }
  if ('IntersectionObserver' in window && !reduceMotion) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.preload = 'auto'; var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.4 });
    $$('[data-autoplay-inview]').forEach(function (v) { vio.observe(v); });
  }
  $$('.qa video').forEach(function (v) { v.addEventListener('play', function () { $$('.qa video').forEach(function (o) { if (o !== v) o.pause(); }); }); });

  /* ---------- sticky bar ---------- */
  var sticky = $('[data-sticky]'), heroCta = $('[data-hero-cta]');
  function updateSticky() { if (sticky && heroCta) sticky.classList.toggle('is-shown', heroCta.getBoundingClientRect().bottom < 0); }
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  updateSticky();

  /* ---------- reveal + tal-tæller ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  renderBuy();
  refreshCart();
  track('view_item', DEFAULT_PLAN, 1);
})();
